<template>
  <v-card height="100%">
    <v-card-title>
      BlueChipCar Wallet
      <v-spacer></v-spacer>
      <v-dialog
        v-model="addFunds"
        max-width="500px"
        :fullscreen="$vuetify.breakpoint.mobile"
        :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : '' "
        v-if="!userId"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color='primary'
            small
            v-bind="attrs"
            v-on="on"
          >
            Add Funds
          </v-btn>
        </template>
        <FundingForm
          ref="fundForm"
          v-on:dialog-close="dialogFundingClose"
        ></FundingForm>
      </v-dialog>
      <v-dialog
        v-model="withdrawFunds"
        max-width="500px"
        :fullscreen="$vuetify.breakpoint.mobile"
        :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : '' "
        v-if="!userId"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color='primary'
            small
            v-bind="attrs"
            v-on="on"
            class="ml-2"
          >
            Withdraw Funds
          </v-btn>
        </template>
        <WithdrawalForm
          v-on:dialog-close="withdrawFunds = false"
        ></WithdrawalForm>
      </v-dialog>
    </v-card-title>

    <v-card-subtitle class="text-h6 text-center">
      <span class="mr-6">Current Balance:</span>
      <span>{{ balance | numberToMoney(true) }}</span>
    </v-card-subtitle>

    <v-tabs
      v-model="tab"
      background-color="blue lighten-5"
      color="blue"
      grow
      icons-and-text
    >
      <v-tab>Shares <v-icon dense>mdi-chart-areaspline</v-icon></v-tab>
      <v-tab>Credits & Debits <v-icon>mdi-bank-transfer</v-icon></v-tab>
      <v-tab>Fees <v-icon>mdi-bank-transfer-out</v-icon></v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card-text>
          <v-simple-table
            dense
            fixed-header
            height="250px"
          >
              <template v-slot:default>
                <thead class="grey lighten-3">
                  <tr>
                    <th class="text-left">Date</th>
                    <th class="text-left">Notes</th>
                    <th class="text-left">Asset</th>
                    <th class="text-right">Transaction</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(transaction, t) in transactions.purchases"
                    :key="t"
                    :class="t % 2 === 0 ? 'blue lighten-5' : ''"
                  >
                    <td class="text-left">
                      {{ transaction.executionTimestamp | timestampToDate }} {{ transaction.executionTimestamp | timestampToTime }}
                    </td>
                    <td class="text-left">
                      {{ transaction.notes }}
                    </td>
                    <td class="text-left">
                      <router-link
                        v-if="transaction.asset"
                        :to="`/asset/${transaction.asset.id}`"
                        >
                          {{ transaction.asset.title }}
                      </router-link>
                    </td>
                    <td class="text-right">
                      {{ transaction.amount | numberToMoney(true) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
        <v-card-text>
          <v-simple-table
            dense
            fixed-header
            height="250px"
          >
              <template v-slot:default>
                <thead class="grey lighten-3">
                  <tr>
                    <th class="text-left">Date</th>
                    <th class="text-left">Notes</th>
                    <th class="text-left">Asset</th>
                    <th class="text-right">Transaction</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(transaction, t) in transactions.outside"
                    :key="t"
                    :class="t % 2 === 0 ? 'blue lighten-5' : ''"
                  >
                    <td class="text-left">
                      {{ transaction.executionTimestamp | timestampToDate }} {{ transaction.executionTimestamp | timestampToTime }}
                    </td>
                    <td class="text-left">
                      {{ transaction.notes }}
                    </td>
                    <td class="text-left">
                      <router-link
                        v-if="transaction.asset"
                        :to="`/asset/${transaction.asset.id}`"
                        >
                          {{ transaction.asset.title }}
                      </router-link>
                    </td>
                    <td class="text-right">
                      {{ transaction.amount | numberToMoney(true) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-tab-item>
      <v-tab-item>
        <v-card-text>
          <v-simple-table
            dense
            fixed-header
            height="250px"
          >
              <template v-slot:default>
                <thead class="grey lighten-3">
                  <tr>
                    <th class="text-left">Date</th>
                    <th class="text-left">Notes</th>
                    <th class="text-left">Asset</th>
                    <th class="text-right">Transaction</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(transaction, t) in transactions.fees"
                    :key="t"
                    :class="t % 2 === 0 ? 'blue lighten-5' : ''"
                  >
                    <td class="text-left">
                      {{ transaction.executionTimestamp | timestampToDate }} {{ transaction.executionTimestamp | timestampToTime }}
                    </td>
                    <td class="text-left">
                      {{ transaction.notes }}
                    </td>
                    <td class="text-left">
                      <router-link
                        v-if="transaction.asset"
                        :to="`/asset/${transaction.asset.id}`"
                        >
                          {{ transaction.asset.title }}
                      </router-link>
                    </td>
                    <td class="text-right">
                      {{ transaction.amount | numberToMoney(true) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import FundingForm from './FundingForm.vue'
  import WithdrawalForm from './WithdrawalForm.vue'

  export default {
    name: 'WalletLedger',

    props: {
      userId: Number
    },

    components: {
      FundingForm,
      WithdrawalForm
    },

    computed: {
      ...mapGetters([
        'walletBalance',
        'transactionHistory',
        'adminUserView',
        'adminUserViewTransactionHistory'
      ])
    },

    data: () => ({
      // Dialog handling.
      addFunds: false,
      withdrawFunds: false,

      balance: 0,
      transactions: [],
      tab: null,
    }),

    watch: {
      addFunds(visible) {
        if (visible) {
          if (this.$refs.fundForm) {
            this.$refs.fundForm.dialogOpen()
          }
        }
      }
    },

    methods: {
      ...mapActions([
        'getWalletBalance',
        'getTransactionHistory',
        'adminGetTransactionHistory'
      ]),

      dialogFundingClose: function () {
        this.addFunds = false
        this.getWalletBalance().then(() => {
          this.balance = this.walletBalance
        })
        this.getTransactionHistory().then(() => {
          this.transactions = Object.assign({}, this.transactionHistory)
        })
      }
    },

    async created() {
      // Admin looking at another user.
      if (this.userId) {
        await this.adminGetTransactionHistory(this.userId).then(() => {
          this.transactions = Object.assign({}, this.adminUserViewTransactionHistory)
          this.balance = this.adminUserView.walletBalance
        })
      }
      // User looking at their account.
      else {
        //await this.getTransactionHistory('ALL').then(() => {
        await this.getTransactionHistory().then(() => {
          this.transactions = Object.assign({}, this.transactionHistory)
          //console.log(this.transactions);
        })

        await this.getWalletBalance().then(() => {
          this.balance = this.walletBalance
        })
      }
    }
  }
</script>
